import * as Sentry from '@sentry/nextjs'

import type { CountMetricName } from '@/constants/analytics/sentryCountMetrics'
import { isEmpty } from '@/utils/general/browserHelper'
import type { ProcessedData } from '@/utils/srp/types'

export type BookingSegmentAttributes = {
  isInternational: boolean
  isRT: boolean
  isCfw?: boolean
}

export const getSrpMetricAttributes = (processedData?: ProcessedData): BookingSegmentAttributes => ({
  isInternational: !!processedData?.isIntl,
  isRT: !isEmpty(processedData?.returnDate),
  isCfw: !!processedData?.isCfw,
})

export const getItineraryMetricAttributes = (
  itineraryData?: { SEARCH_DETAILS?: { sectorType?: string; journeyType?: string } },
  isCfw?: boolean
): BookingSegmentAttributes => {
  const searchDetails = itineraryData?.SEARCH_DETAILS ?? {}
  return {
    isInternational: searchDetails.sectorType === 'INTL',
    isRT: searchDetails.journeyType !== 'ONE_WAY',
    isCfw: !!isCfw,
  }
}

export const getHomeSearchMetricAttributes = ({
  isIntl,
  intl,
  tripType,
  isCfw,
}: {
  isIntl?: string
  intl?: string
  tripType?: string
  isCfw?: boolean
}): BookingSegmentAttributes => ({
  isInternational: isIntl === 'y' || intl === 'y',
  isRT: tripType === 'R',
  isCfw: !!isCfw,
})

export const countMetric = (metric: CountMetricName, value: number, attributes?: Record<string, any>) => {
  try {
    Sentry.metrics.count(metric, value, {
      attributes: {
        ...attributes,
      },
    })
  } catch (error) {
    console.error('Error counting metric:', error)
  }
}
